import { createTheme } from "@mui/material";
import { plPL, enUS } from "@mui/material/locale";
import { LicenseInfo } from "@mui/x-license";
import {
  enUS as enUSdataGrid,
  plPL as plPLdataGrid,
} from "@mui/x-data-grid-pro/locales";
import { breakpoints } from "./Modules/breakpointsModule";
import { typography } from "./Modules/typographyModule";
import { palette } from "./Modules/paletteModule";
import { components } from "./Components";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUIX_LICENSE_KEY as string);

export const theme = ({ language }: { language: string }) =>
  createTheme(
    {
      breakpoints,
      palette,
      typography,
      components,
    },
    language === "pl" ? plPLdataGrid : enUSdataGrid, // x-data-grid translations
    language === "pl" ? plPL : enUS // core translations
  );

export const themeOptions = () => ({
  palette,
  components,
  typography,
});
